import { TagsWrapper } from './Tags.styles';
import { StyledTechDiv } from '../ArticleCard/ArticleCard.styles';
import { useEffect, useState } from 'react';
import { createClient } from 'contentful';

const client = createClient({
  space: process.env.CONTENTFUL_SPACE || ``,
  accessToken: process.env.CONTENTFUL_ACCESS_TOKEN || ``,
});

const Tags = ({ mtags }: any) => {
  const [tags, setTags] = useState<any[] | []>([]);

  useEffect(() => {
    const tagsPromises = mtags.map((el: any) => client.getTag(el.sys.id));
    Promise.all(tagsPromises).then((tags) => {
      setTags(tags);
    });
  }, [mtags]);

  return !!tags.length ? (
    <TagsWrapper>
      {tags.map((el): any => (
        <StyledTechDiv key={el.name}>{el.name}</StyledTechDiv>
      ))}
    </TagsWrapper>
  ) : null;
};

export default Tags;
